module.exports = __webpack_public_path__ + "img/n-kaquan.aeaba120.svg";